<template>
  <form novalidate ref="updateFileForm" @submit.prevent="() => {}">
    <v-row no-gutters>
      <v-col cols="8">
        <v-card max-width="1200" flat color="transparent">
          <v-card-title class="mb-10">
            <h4>{{ data.title ? `${data.title} файл` : `Создать файл` }}</h4>
            <v-btn
              link
              small
              outlined
              color="primary"
              class="ml-2"
              :to="{
                name: 'page-media-library'
              }"
              :loading="loading"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <PageContent height="85">
              <v-container>
                <v-row justify="space-between">
                  <v-col cols="6">
                    <v-col cols="12">
                      <span>Название *</span>
                      <v-text-field
                      id="name"
                        autofocus
                        outlined
                        :error-messages="validationErrors.name"
                        :disabled="loading"
                        :loading="loading"
                        v-model.trim="fields.name"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        autofocus
                        outlined
                        readonly
                        :disabled="loading"
                        :loading="loading"
                        :value="fields.fileName"
                      />
                    </v-col>
                    <v-col cols="12">
                      <span>Оригинальное имя</span>
                      <v-text-field
                        outlined
                        disabled
                        :loading="loading"
                        :value="fields.originalFileName"
                      />
                    </v-col>
                    <v-col cols="12">
                      <span>Тип</span>
                      <v-text-field
                        outlined
                        disabled
                        :loading="loading"
                        :value="fields.type"
                      />
                    </v-col>
                    <v-col cols="12">
                      <span>Ширина</span>
                      <v-text-field
                        outlined
                        disabled
                        :loading="loading"
                        :value="fields.width"
                      />
                    </v-col>
                    <v-col cols="12">
                      <span>Высота</span>
                      <v-text-field
                        outlined
                        disabled
                        :loading="loading"
                        :value="fields.height"
                      />
                    </v-col>
                    <v-col cols="12">
                      <span>Формат</span>
                      <v-text-field
                        outlined
                        disabled
                        :loading="loading"
                        :value="fields.format"
                      />
                    </v-col>
                    <v-col cols="12">
                      <span>Размер</span>
                      <v-text-field
                        outlined
                        disabled
                        :loading="loading"
                        :value="fields.size"
                      />
                    </v-col>
                    <v-col cols="12">
                      <span>Альтернативный текст (<TranslationIcon/>)</span>
                      <v-text-field
                        outlined
                        :disabled="loading"
                        :loading="loading"
                        v-model.trim="fields.altText"
                      />
                    </v-col>
                  </v-col>
                  <v-col cols="6">
                    <v-col>
                      <MediaFilePicker
                        is-reversed
                        payload-only
                        return-file-only
                        hide-delete
                        :label="''"
                        :button-name="'Заменить...'"
                        :multiple="false"
                        :file-type="$options.mediaTypesByKeys[data.type]"
                        :value="data.id"
                        @change="updateFile"
                      />
                    </v-col>
                  </v-col>
                </v-row>
              </v-container>
            </PageContent>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <ManageSidePanel
          ref="manageSidePanel"
          :is-new="!data.id"
          :created-at="data.createdAt"
          :updated-at="data.updatedAt"
          :published-at="data.publishedAt || ''"
          :is-loading="loading"
          :entity-id="data.id"
          :entity-type="'mediaLibrary'"
          @delete="$emit('delete-file')"
          @cancel="$router.push({ name: 'page-media-library' })"
          @submit="submit"
          :language="language"
          :translations="fields.translations"
          @update-translations="Object.assign(fields.translations, $event)"
          @language-update="$emit('language-update', $event)"
        />
      </v-col>
    </v-row>
  </form>
</template>
<script>
import validationRules from '@/pages/file/form/validation-rules'
import FormAbstract from '@/components/abstract/form'
import ManageSidePanel from '@/components/manage-side-panel'
import validationTranslations from '@/mixins/translations/validationTranslations.mix.js'
import MediaFilePicker from '@/components/media-file-picker/MediaFilePicker'
import TranslationIcon from '@/components/translation-icon/translationIcon'
import { mediaTypesByKeys } from '@/configs/mediaFileTypes'
import PageContent from '@/components/page-content/PageContent.vue'

export default {
  name: 'FormFile',
  mediaTypesByKeys: mediaTypesByKeys(),
  validationRules,
  extends: FormAbstract,
  mixins: [validationTranslations],
  components: {
    PageContent,
    TranslationIcon,
    MediaFilePicker,
    ManageSidePanel
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    language: {
      type: String,
      default: null
    },
    isNew: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fields: {
        name: null,
        fileName: null,
        originalFileName: null,
        type: null,
        width: null,
        height: null,
        format: null,
        size: null,
        altText: null
      }
    }
  },
  watch: {
    data (data) {
      this.populate(data)
    }
  },
  methods: {
    updateFile (file) {
      this.$emit('submit', {
        data: { file, mediaLibrary: true }
      })
    },
    async submit () {
      const isValid = await this.validate()
      if (!isValid) {
        this.mixScrollToError(this.$v)
        return
      }
      // if (!this.mixIsValidTranslations(this.fields.translations)) {
      //   this.$errorMsg('Не выбран ни один язык для контента!')
      //   return
      // }
      const { altText, name } = this.fields
      const payload = this.composeFormData({
        altText,
        name
      })
      payload.mediaLibrary = true
      this.$emit('submit', { data: payload })
    }
  }
}
</script>
